import { POINT_LEDGER_STATUS } from '../name-space';

export const statusFilter = (status: number) => {
  switch (status) {
    case POINT_LEDGER_STATUS.MINE:
      return 'Played a Game';
    case POINT_LEDGER_STATUS.REFERRAL:
    case POINT_LEDGER_STATUS.REFERRAL_MY:
      return 'Invite Bonus';
    case POINT_LEDGER_STATUS.BONUS:
      return 'Claimed Bonus';
    default:
      return 'Not Found';
  }
};
